<template>
    <div :class="{'hidden':hidden}" class="pagination-container">
        <!-- 分页 -->
        <el-pagination
            :locale="zhCn"
            v-model:current-page="props.pageNo"
            v-model:page-size="props.pageSize"
            :page-sizes="props.pageSizes"
            :background="props.background"
            :layout="props.layout"
            :total="props.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            />
    </div>
</template>
  
<script setup>
    import { scrollTo } from '@/utils/scroll-to'
    import { defineProps,defineEmits  } from 'vue';

    const props = defineProps({
        //总数量
        total:{
            type:Number,
            default:1
        },
        //当前页码
        pageNo:{
            type:Number,
            default:1
        },
        //当前页数
        pageSize:{
        type:Number,
            default:10
        },
        //选择分页条数
        pageSizes:{
        type:Array,
            default:()=>[10, 20, 30, 40]
        },
        //布局
        layout:{
        type:String,
            default:'sizes, prev, pager, next, jumper'
        },
        background:{
            type:Boolean,
            default:true
        },
        autoScroll: {
            type: Boolean,
            default: true
        },
    })

    const emit = defineEmits(['handleChange','update:pageNo','update:pageSize'])
    const handleSizeChange = (val) => {
        //修改pageNo的值
        emit('update:pageSize',val)
        //调用请求
        emit('handleChange')
        if (props.autoScroll) {
            scrollTo(0, 800)
        }
    }
    const handleCurrentChange = (val) => {
        //修改pageNo的值
        emit('update:pageNo',val)
        //调用请求
        emit('handleChange')
        if (props.autoScroll) {
            scrollTo(0, 800)
        }
    }
</script>
  
  <style scoped>
  .pagination-container {
    background: #fff;
    padding: 32px 16px;
  }
  .pagination-container.hidden {
    display: none;
  }
  </style>
  